import styled from 'styled-components'

import { device } from 'src/Styled/variables'

export const Link = styled.a`
  color: ${({ theme }) => theme.color.darkGrey};
  font-weight: 600;
  text-decoration: none;
  border-bottom: 1px dashed ${({ theme }) => theme.color.darkGrey};

  &:hover {
    border-bottom-style: solid;
  }
`
export const Title = styled.h2`
  margin-bottom: 29px;
  color: ${({ theme }) => theme.color.darkGrey};
`

export const Body = styled.div`
  background-color: ${({ theme }) => theme.color.white};
  color: ${({ theme }) => theme.color.darkGrey};
  text-align: center;
  padding: 20px;
  padding-bottom: 50px;
  border-radius: 5px;

  svg {
    height: 170px;
    width: 280px;
    transition: 0.3s;
  }
`

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 80px);
  user-select: none;
  max-width: 1120px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  @media ${device.mobileMin} {
    padding: 0 40px;
  }
  > div {
    width: 100%;
  }
`
export const ButtonWrapper = styled.div`
  margin: 40px auto 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`
